import Selector from './Selector.view';

export default Selector;
